import { Calendar, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDateFilter, DATE_PRESETS } from "@/contexts/DateFilterContext";

const DateFilterDropdown = ({ compact = false }) => {
  const { preset, selectPreset, getDisplayLabel } = useDateFilter();

  const presetOptions = [
    { value: DATE_PRESETS.TODAY, label: "Today" },
    { value: DATE_PRESETS.YESTERDAY, label: "Yesterday" },
    { value: DATE_PRESETS.LAST_7_DAYS, label: "Last 7 days" },
    { value: DATE_PRESETS.LAST_14_DAYS, label: "Last 14 days" },
    { value: DATE_PRESETS.LAST_30_DAYS, label: "Last 30 days" },
    { value: DATE_PRESETS.LAST_90_DAYS, label: "Last 90 days" },
    { divider: true },
    { value: DATE_PRESETS.THIS_MONTH, label: "This month" },
    { value: DATE_PRESETS.LAST_MONTH, label: "Last month" },
    { value: DATE_PRESETS.THIS_QUARTER, label: "This quarter" },
    { value: DATE_PRESETS.LAST_QUARTER, label: "Last quarter" },
    { divider: true },
    { value: DATE_PRESETS.THIS_YEAR, label: "This year" },
    { value: DATE_PRESETS.LAST_YEAR, label: "Last year" },
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className={`${compact ? "w-full justify-between" : "gap-2"} bg-white border-slate-200 hover:bg-slate-50`}
        >
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4 text-slate-500" />
            <span className="text-sm font-medium text-slate-700">
              {getDisplayLabel()}
            </span>
          </div>
          <ChevronDown className="w-4 h-4 text-slate-400" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        {presetOptions.map((option, index) => 
          option.divider ? (
            <DropdownMenuSeparator key={`divider-${index}`} />
          ) : (
            <DropdownMenuItem
              key={option.value}
              onClick={() => selectPreset(option.value)}
              className={preset === option.value ? "bg-slate-100" : ""}
            >
              {option.label}
            </DropdownMenuItem>
          )
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DateFilterDropdown;
